import React, { FunctionComponent } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box } from '../box';
import { Paper } from '../paper';
import { LinearProgress } from '../linear-progress';
import { Typography } from '../typography';

export interface AreaRightSideBoxProps {
  heading?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
  error?: boolean;
}

const useStyles = makeStyles()({
  contentRoot: {
    opacity: 1,
    transition: 'opacity .5s linear',
  },
  contentLoadingTransparency: {
    opacity: 0.6,
  },
  error: {
    opacity: 0.3,
    pointerEvents: 'none',
  },
  paper: {
    overflow: 'hidden',
  }
});

export const AreaRightSideBox: FunctionComponent<AreaRightSideBoxProps> = ({ heading, children, isLoading = false, error = false }) => {
  const { classes } = useStyles();

  return (
    <Box>
      <Paper className={`${classes.paper} ${error && classes.error}`}>
        {!error && <LinearProgress show={isLoading} />}
        <Box className={`${classes.contentRoot} ${isLoading ? classes.contentLoadingTransparency : ''}`}>
          {heading && (
            <Box px={2} pt={1}>
              <Typography variant="h6">{heading}</Typography>
            </Box>
          )}
          {children}
        </Box>
      </Paper>
    </Box>
  );
};

AreaRightSideBox.displayName = 'AreaRightSideBox';
